const state = {
  segments: [],
  segment_types: [],
}

const getters = {
  
}

const actions = {
  requestSegmentIndex({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {

      this._vm.$axios.get(api.segmentIndex()).then(function(response){
                  commit("_requestSegmentIndex", response.data)
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  },
  requestSegmentTypeIndex({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {

      this._vm.$axios.get(api.segmentTypeIndex()).then(function(response){
                  commit("_requestSegmentTypeIndex", response.data)
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  },
  requestSegmentCreate({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {

      this._vm.$axios.post(api.segmentCreate(), payload).then(function(response){
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  }
}

const mutations = {
  _requestSegmentIndex(state, payload){
    state.segments = payload
  },
  _requestSegmentTypeIndex(state, payload){
    state.segment_types = payload
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
